<!--
 * @Descripttion:
 * @version:
 * @Author: wl
 * @Date: 2020-05-13 13:27:23
 * @LastEditors: wl
 * @LastEditTime: 2020-06-23 15:46:32
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    window.addEventListener("unload", this.getVillage());
  },
  methods: {
    getVillage() {
      this.$api.build.communityName().then((res) => {
        if (res.code == 0) {
          this.$store.commit("setvillage", res.data);
        }
      });
    },
  },
};
</script>

<style lang='scss'>
/* 页面样式 */
@import "./assets/main.css";
/* 页面样式 */
@import "./assets/css/b.css";
/* 框架样式 */
@import "./assets/css/project.scss";
@import "./assets/css/ly.css";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #484a4d;
  /* background:  #b6bbbb21; */
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  // 设置为none时，网页文本不可被复制
  user-select: text;
  -moz-user-select: text; /*火狐*/
  -webkit-user-select: text; /*webkit浏览器*/
  -ms-user-select: text; /*IE10*/
  -khtml-user-select: text; /*早期浏览器*/
}
.el-tooltip__popper {
  font-size: 14px;
  max-width: 50%;
  background-color:rgba($color: #000000, $alpha: 0.8) !important;
  //  background-color:#707070  !important;
  color: #fff  !important;
  margin-top: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue